import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewMomDetails from "./viewMomDetails";
import {
    getMomBymeetingId
} from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
    momBymeetingId: state.ConductCampReducer.momBymeetingId,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ getMomBymeetingId }, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(ViewMomDetails);
